// extracted by mini-css-extract-plugin
module.exports = {"google":"logo_google__9Iv6u"};